import { createSlice } from '@reduxjs/toolkit';
import ApiClientConnector from 'src/api/ApiClientConnector';

const initialState = {
    hotels: [],
    hotelImages: [],
    isDetailView: false,
    isManageView: false,
    selectedHotelId: null,
    isEditView: false,
    selectedItem: null
};
export const ManageHotelSlice = createSlice({
    name: 'hotels',
    initialState,
    reducers: {
        getHotelResultList: (state, action) => {
            state.hotels = action.payload;
        },
        getHotelImages: (state, action) => {
            state.hotelImages = action.payload;
        },
        changeSelectedItemId: (state, action) => {
            state.selectedHotelId = action.payload;
        },
        changeDetailView: (state, action) => {
            state.isDetailView = action.payload;
        },
        changeManageView: (state, action) => {
            state.isManageView = action.payload;
        },
        changeEditView: (state, action) => {
            state.isEditView = action.payload;
        },
        changeSelectedItem: (state, action) => {
            state.selectedItem = action.payload;
        },
        updateHotelContentDescription: (state, action) => {
            if (state.selectedItem) {
                state.selectedItem.Content = {
                    ...state.selectedItem.Content,
                    Description: action.payload
                };
            }
        }
    },
});

export const {
    getHotelResultList,
    changeSelectedItemId,
    changeDetailView,
    changeManageView,
    changeEditView,
    changeSelectedItem,
    updateHotelContentDescription
} = ManageHotelSlice.actions;

export const fetchHotels = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.hotels.post(criteria);
    const hotelsArray = result.Results || [];
    dispatch(getHotelResultList(hotelsArray));
    return result;
};

export const fetchHotelImages = (instance, accounts, propertyId, provider) => async (dispatch,getState) => {
    const client = await ApiClientConnector(instance, accounts);
    const sessionId = getState().hotelSearchReducer?.sessionId;
    const result = await client.hotels.getHotelImages(propertyId, provider, sessionId);
    return result;
};

export const fetchHotelList = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.hotels.getHotels(criteria);
    dispatch(getHotelResultList(result));
    return result;
};

export const fetchSelectedHotel = (instance, accounts, hotelId) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.hotels.getHotelById(hotelId);
    dispatch(changeSelectedItem(result));
    return result;
};

export const updateHotelDescription = (instance, accounts, hotelId, description) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.hotels.updateHotelDescription(hotelId, description);
    return dispatch(updateHotelContentDescription(result?.Description));
};

export default ManageHotelSlice.reducer;